// src/api/auth.js
export async function login(username, password) {
  // Keep payload the same
  const res = await fetch('/api/kraken-auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json,text/plain,*/*',
    },
    body: JSON.stringify({ username, password }),
    credentials: 'include' // harmless if server ignores; OK for future cookies
  });

  const raw = await res.text();
  if (!res.ok) {
    // Surface server text as before
    throw new Error(`Login failed (${res.status}). Server: ${raw}`);
  }

  // Backward + forward compatible parsing:
  // - if server still returns "ok", keep behavior
  // - if server returns JSON with token & user info, persist it
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    parsed = null;
  }

  if (parsed && typeof parsed === 'object') {
    const {
      token,
      id,
      user_id,
      username: uname,
      full_name,
      email,
      roles,
      country,
      address,
      phone_number,
    } = parsed;

    // Store JWT and a compact user snapshot for the rest of the app
    if (token) {
      try { localStorage.setItem('squid.token', token); } catch {}
    }

    const userObj = {
      id: id || user_id || null,
      username: uname || username,
      name: full_name || null,
      email: email || null,
      roles: Array.isArray(roles) ? roles : [],
      country: country || null,
      address: address || null,
      phone: phone_number || null,
      // you can add exp/iat later if you include it in the token claims
    };

    try { localStorage.setItem('squid.user', JSON.stringify(userObj)); } catch {}

    // Return "ok" so existing callers don't change
    return 'ok';
  }

  // Fallback to the old contract if the body was plain text
  return raw || 'ok';
}